<template>
  <div id="page-content-wrapper" class="admin-content-area">
    <div class="container-fluid xyz">
        <div class="page-header-top-container">
            <div class="page-name" id="benefitHeader">{{pageTitle}}</div>
            <button type="submit" class="back_button btn btn-primary pull-right" v-on:click.prevent="buttonBack">Back</button>
        </div>

        <div class="admin-page-content">
            <form id="changeProfile">
                <div class="forms-container">
                  <div class="row no-margin">
                      <div class="col-6 forms-block">
                          <div class="col-3 paddingleft0">
                              <div class="form-label" for="description">Social Media :</div>
                          </div>
                          <div class="col-9 paddingleft0">
                              <input v-model="socialMedia" type="text" class="form-control" id="socialMedia"
                              placeholder="Social Media" />
                              <div class="requiredstar">*</div>
                              <font class="text-danger">{{socialMediaError}}</font>
                          </div>
                      </div>

                      <div v-show="email != null" class="col-6 forms-block">
                          <div class="col-3 paddingleft0">
                              <div class="form-label" for="description">Email :</div>
                          </div>
                          <div class="col-9 paddingleft0">
                              <input v-model="email" type="text" class="form-control" id="email" placeholder="Email" />
                              <div class="requiredstar">*</div>
                              <font class="text-danger">{{emailError}}</font>
                          </div>
                      </div>

                      <div class="col-6 forms-block">
                          <div class="col-3 paddingleft0">
                              <div class="form-label" for="description">Profile User :</div>
                          </div>
                          <div class="col-9 paddingleft0">
                              <input v-model="profileUser" type="text" class="form-control" id="profileUser"
                              placeholder="Profile User" />
                              <div class="requiredstar">*</div>
                              <font class="text-danger">{{profileUserError}}</font>
                          </div>
                      </div>

                      <div class="col-6 forms-block">
                          <div class="col-3 paddingleft0">
                              <div class="form-label" for="description">Company :</div>
                          </div>
                          <div class="col-9 paddingleft0">
                              <v-select v-model="company"
                                              @change="changedValue"
                                              @input="changedValueUser()"
                                              name="companyId"
                                              id="companyId"
                                              label="text"
                                              :filterable="false"
                                              :options="companyArr"
                                              @search="onSearchCompany"
                                              placeholder="Select Company">
                                        <template slot="no-options">
                                            Search Company...
                                        </template>
                                        <template slot="option" slot-scope="option">
                                            <div class="d-center">
                                                {{ option.text }}
                                            </div>
                                        </template>
                                        <template slot="selected-option" slot-scope="option">
                                            <div class="selected d-center">
                                                {{ option.text }}
                                            </div>
                                        </template>
                                    </v-select>
                              <!--input v-model="company" type="text" class="form-control" id="company"
                              placeholder="Company" /-->
                              <div class="requiredstar">*</div>
                              <font class="text-danger">{{companyError}}</font>
                          </div>
                      </div>


                      <template v-for="page in pages">

                      <!-- {{ page }} -->



                          <div v-if="page != ''" class="col-6 forms-block">
                              <div class="col-3 paddingleft0">
                                  <div class="form-label" for="description">{{ pageNameTitle }} :</div>
                              </div>
                              <div class="col-9 paddingleft0">
                                  <input :value="page" type="text" class="form-control" id="pageName"
                                  placeholder="Page Name" disabled/>
                                  <div class="requiredstar">*</div>
                                  <font class="text-danger">{{pageNameError}}</font>
                              </div>
                          </div>
                        </template>




                      <div class="col-6 forms-block">
                          <div class="col-3 paddingleft0">
                              <div class="form-label" for="description">Created By :</div>
                          </div>
                          <div class="col-9 paddingleft0">
                              <input v-model="createdBy" type="text" class="form-control" id="createdBy" placeholder="Created By" />
                              <div class="requiredstar">*</div>
                              <font class="text-danger">{{createdByError}}</font>
                          </div>
                      </div>

                  </div>

                  <!--Error Alert-->
                    <div class="row clearfix" >
                        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                            <div class="alert alert-danger" id="alertError">
                                <!--<button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button>-->
                                <strong id="errorMsg" class="error"></strong>
                            </div>
                        </div>
                    </div>
                    <div class="clearfix"></div>

                    <!--Buttons-->
                    <div class="row clearfix"></div>
                    <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                        <div class="button-demo">
                            <input id="addBenifitBtn" type="submit" value="Update" class="btn btn-primary" v-on:click.prevent="UpdateAccount()">
                            <!--<input id="addMedia" type="submit" value="Save" class="btn btn-primary" v-on:click.prevent="AddUpdateSlider()"></input>-->
                            <input id="CancelBenifit" type="submit" value="Cancel" class="back_button btn btn-primary" v-on:click.prevent="buttonBack">
                        </div>
                    </div>

                </div>


            </form>
        </div>


    </div>
    <app-backend-footer></app-backend-footer>
  </div>

</template>

<script>
  var self;
  import Vue from 'vue';
  import BackendFooter from '@/components/backend/partials/Footer';
  import SessioMixin from '../../../mixins/sessionmixin';
  import {HTTP} from '../../../http-common';
  import vSelect from 'vue-select';


export default {
    name: 'ViewSocialAccount',
    props: [''],
    mixins: [SessioMixin],
    components: {
        'app-backend-footer': BackendFooter,
        'v-select': vSelect,
    },
    data() {
        return {
          pageTitle: 'View Account',
          accountId: '',

          socialMedia: '',
          socialMediaError: '',

          email: '',
          emailError: '',

          profileUser: '',
          profileUserError: '',

          company: '',
          companyArr: [],
          companyError: '',




          pageName: '',
          pageNameError: '',

          pages: [],

          createdBy: '',
          createdByError: '',

          pageNameTitle: 'Page Name',

          fbToken: '',
          userId : 0,
        }
    },
    mounted: function () {
        self = this;
        var userObj = localStorage.getItem("user_obj");
        var userJson = JSON.parse(userObj);
        self.userId = userJson.id;
        self.checkLogin();
        self.loadCompanies();
        if(this.$route.query.token) {
          self.fbToken = this.$route.query.token;
          self.addFacebookUserDetail();
        } else {
          self.accountId = this.$route.query.id;
          self.getAccountDetail();
        }

        $(".alert-danger").addClass("hide");
    },
    watch: {

    },
    methods: {
      UpdateAccount: function() {
        var config = {
              headers: {Authorization: "Bearer " + localStorage.getItem("api_token")},
          };
          var fields = {
              id: self.accountId,
              company_id: self.company.value
          };
          self.showLoader();
          HTTP.post('socialmedia/add_company',fields, config)
              .then(function (response) {
                  if (response.data.code == '200') {
                      // console.log(response.data.content);
                      self.$swal({
                          type: 'success',
                          text: 'Social Media Connected Successfully',
                          showConfirmButton: false,
                          timer: 5000,
                      });
                      $("#addBenifitBtn").prop("disabled", true);
                      $(".back_button").prop("disabled", true);
                      setTimeout(function () {
                          self.buttonBack();
                      }, 5000);
                  }
                  self.hideLoader();
              })
              .catch(function (err) {
                if (err.response.status == 0) {
                  if (err.response.status == 0) {
                    self.error = "Remote server can not be reachable";
                  } else {
                    //redirect to login page if user not authenticated
                    if (err.response.status == 401) {
                      //clear previous data
                      localStorage.removeItem("user_obj");
                      localStorage.removeItem("api_token");
                      localStorage.removeItem("profile_image");
                      self.$router.push("/login");
                      //EventBus.$emit("logged-in", true, "", "");
                    }
                    self.error = err.response.data.message;
                  }
                }
                  self.hideLoader();
              })

      },
      changedValue: function (value) {
          //console.log(value);
      },
      onSearchCompany(search, loading) {
          if (search.length > 2) {
              if (typeof (loading) != "undefined") {loading(true);}
              this.loadCompanies(loading, search, this);
          }
      },
      changedValueUser: function () {
      },
      loadCompanies(loading, search, vm) {
          search = (search === null || typeof (search) === "undefined" || search == '') ? '' : search;
          if (search != '') {
              var config = {
                  //headers: {Authorization: "Bearer " + localStorage.getItem("api_token")},
                  params: {
                      search: search
                  }
              };
          } else {
              var config = {
                  //headers: {Authorization: "Bearer " + localStorage.getItem("api_token")},
              };
          }
          HTTP.get("ce-getcompany", config)
                  .then(function (response) {
                      self.companyArr = [];
                      $.each(response.data.content, function (i) {
                          /*self.companyArr.push(response.data.content[i].text);*/
                          self.companyArr.push(response.data.content[i]);
                      });
                      if (typeof (loading) != "undefined") {
                          loading(false);
                      }
                  })
                  .catch(function (err) {
                      if (err.response.status == 0) {
                          self.error = "Remote server can not be reachable";
                      } else {
                          //redirect to login page if user not authenticated
                          if (err.response.status == 401) {
                              //clear previous data
                              localStorage.removeItem("user_obj");
                              localStorage.removeItem("api_token");
                              localStorage.removeItem("profile_image");
                              self.$router.push("/login");
                              //EventBus.$emit("logged-in", true, "", "");
                          }
                          self.error = err.response.data.message;
                      }
                  });
      },
      buttonBack() {
          $(".back_button").prop("disabled", false);
          self.$router.push('/backend/social/listaccount');
      },
      addFacebookUserDetail: function() {
        // self.fbToken
        window.location = process.env.ROOT_API + '/socialmedia/connect/facebook/userdetail?auth_id=' + self.userId + '&token=' + self.fbToken;
          // var config = {
          //     headers: {Authorization: "Bearer " + localStorage.getItem("api_token")},
          //     params: {
          //           token: self.fbToken,
          //           auth_id: self.userId,
          //       }
          // };
          // self.showLoader();
          // HTTP.get("socialmedia/connect/facebook/userdetail", config)
          //         .then(function (response) {

          //             self.hideLoader();
          //         })
          //         .catch(function (err) {
          //             if (err.response.status == 0) {
          //                 self.error = "Remote server can not be reachable";
          //             } else {
          //                 //redirect to login page if user not authenticated
          //                 if (err.response.status == 401) {
          //                     //clear previous data
          //                     localStorage.removeItem("user_obj");
          //                     localStorage.removeItem("api_token");
          //                     localStorage.removeItem("profile_image");
          //                     self.$router.push("/login");
          //                     //EventBus.$emit("logged-in", true, "", "");
          //                 }
          //                 self.error = err.response.data.message;
          //             }
          //         });

      },
      getAccountDetail: function () {
          var config = {
              headers: {Authorization: "Bearer " + localStorage.getItem("api_token")},
          };
          var fields = {
              id: self.accountId
          };
          self.showLoader();
          HTTP.post('socialmedia/profile/get',fields, config)
              .then(function (response) {
                  if (response.data.code == '200') {
                      console.log(response.data.content);
                      $("#socialMedia").prop('disabled', true);
                      self.socialMedia = self.capitalizeFirstLetter(response.data.content.social_media_type);
                      $("#email").prop('disabled', true);
                      self.email = response.data.content.email;
                      console.log('email ==', self.email);
                      $("#profileUser").prop('disabled', true);
                      self.profileUser = response.data.content.profile_name;
                      self.company = {value: response.data.content.company_id, text: response.data.content.company_name};

                      var i = 0;
                      response.data.content.metadata.forEach(element => {
                        // console.log(element.key);
                        // var myPageName = element.key.concat(i);//  + i;
                        // console.log(myPageName);
                        if(element.key.includes("fb_page_name") || element.key.includes("linkedin_company_name")) {
                          $("#pageName").prop('disabled', true);

                          self.pages.push(element.value);
                          i++;

                          self.pageName = element.value;
                          self.pageNameTitle = 'Page Name';
                        } else if(element.key == "insta_account_type") {
                          self.pages.push(element.value);
                          $("#pageName").prop('disabled', true);
                          i++;
                          self.pageName = element.value;
                          self.pageNameTitle = 'Account Type';
                        }


                        //
                      });

                      console.log("pages = ",self.pages);
                      $("#createdBy").prop('disabled', true);
                      self.createdBy = self.capitalizeFirstLetter(response.data.content.updater_first_name) + " " + self.capitalizeFirstLetter(response.data.content.updater_last_name);
                  }
                  self.hideLoader();
              })
              .catch(function (err) {
                if (err.response.status == 0) {
                  if (err.response.status == 0) {
                    self.error = "Remote server can not be reachable";
                  } else {
                    //redirect to login page if user not authenticated
                    if (err.response.status == 401) {
                      //clear previous data
                      localStorage.removeItem("user_obj");
                      localStorage.removeItem("api_token");
                      localStorage.removeItem("profile_image");
                      self.$router.push("/login");
                      //EventBus.$emit("logged-in", true, "", "");
                    }
                    self.error = err.response.data.message;
                  }
                }
                  self.hideLoader();
              })
      },
    }

}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/backend/socialmedia/ViewSocialAccount.vue